import http from "./http";

/* GET FEATURED MEDIA (main banner) */
export const getFeaturedMedia = async () => {
  const res = await http.get("media_get.php");
  return res.data;
};

/* UPDATE FEATURED MEDIA (main banner) */
export const updateFeaturedMedia = async (data) => {
  const res = await http.post("media_update.php", data);
  return res.data;
};

/* GET SECTION IMAGES */
export const getSectionImages = async () => {
  const res = await http.get("media-section.php?action=get");
  return res.data;
};

/* ADD SECTION IMAGE */
export const addSectionImage = async (data) => {
  const res = await http.post("media-section.php?action=add", data);
  return res.data;
};

/* DELETE SECTION IMAGE */
export const deleteSectionImage = async (id) => {
  const params = new URLSearchParams();
  params.append("id", id);
  const res = await http.post("media-section.php?action=delete", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return res.data;
};
